/**
 * Opciones para el Menu - Selector de Vistas
 */
const viewOptions = [
  {
    id: 1,
    label: 'RESUMEN',
    component: 'Resumen',
    src: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn-resumen',
    show: true,
  },
  {
    id: 2,
    label: 'BARRAS',
    component: 'Barras',
    src: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn-barras',
    show: true,
  },
  {
    id: 3,
    label: 'DISTRIBUCIÓN',
    component: 'Distribution',
    src: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn-spider',
    show: true,
  },
  {
    id: 4,
    label: 'FUERZA',
    component: 'Fuerza',
    src: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn-fuerza',
    show: true,
  },
  { id: 5, label: 'TABLA', component: 'Tabla', src: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn-tabla', show: true },
  // { id: 6, label: 'CANCHA', component: 'Cancha', src: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn-cancha', show: true },
  {
    id: 7,
    label: 'TENDENCIA LIVE',
    component: 'TendenciaLive',
    src: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn-tendencia',
    show: true,
    banner: 'Popup_LiveTrend_OP',
  },
  // { id: 8, label: 'GOLSTATS LIVE', component: 'GolstatsLive', src: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn-golstats-live', show: true },
  {
    id: 9,
    label: 'xG',
    component: 'Xg',
    src: 'https://golstatsimages.blob.core.windows.net/todoelfut/icn_xg',
    show: true,
    banner: 'Popup_xG_OP',
  },
];

/**
 * Opciones para los tipos de filtros
 */
const filterOptions = [
  { parentAnalysis: [1, 2, 3], value: 0, text: 'Realizado', block: 1 },
  { parentAnalysis: [1, 2, 3], value: 1, text: 'Recibido', block: 1 },
  { parentAnalysis: [1], value: 0, text: 'Posesión', block: 2 },
  { parentAnalysis: [1, 2], value: 0, text: 'Origen de gol realizado', block: 3 },
  { parentAnalysis: [1, 2], value: 1, text: 'Origen de gol recibido', block: 3 },
];

/**
 * parentAnalysis inside filterOptions
 * @type {({name: string, id: number}|{name: string, id: number}|{name: string, id: number})[]}
 */
const analysisTypeOptions = [
  {
    name: 'Resultado de partido',
    id: 1,
  },
  {
    name: 'Goles',
    id: 2,
  },
  {
    name: 'Tiros de esquina',
    id: 3,
  },
];

exports.viewOptions = viewOptions;
exports.filterOptions = filterOptions;
exports.analysisTypeOptions = analysisTypeOptions;
